require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./muse-bolo-1-8-1-1.json") })
        }
      }, "path---muse-bolo-1-8-1-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---muse-bolo-1-8-1-1!./.cache/json/muse-bolo-1-8-1-1.json
// module id = 505
// module chunks = 231608221292675